import { View } from "binder"
import { ClassListEditorViewModel } from "./classListEditor-viewModel"

export class ClassListEditorView extends View<ClassListEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-AFD3D523-F36A-4CCE-A98B-A515A46ABD56"
    }
    loadHtml(): string {
        let element = require('./classListEditor.html').default;
        let style = require('./classListEditor.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set value(v: string) { this._value = v; } public get value(): string { return this._value;} private _value: string;
    public set suggestions(v: string[]) { this._suggestions = v; } public get suggestions(): string[] { return this._suggestions;} private _suggestions: string[];

}
